import { styles } from "./form";
import { useFormik } from "formik";
import { EnSchema, initialValues } from "./en_schema";
import { ArSchema } from "./ar_schema";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import {useI18n} from "@/i18n/I18nProvider"
import { arFont, enFont } from "@/styles/font";
import { submitForm } from "../../utils/become_partner";

export default function Form({ color }) {
  const { t, locale } = useI18n();

  const onSubmit = async (values, actions) => {
    await submitForm("27", values, actions, t);
  };
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: initialValues,
    validationSchema: locale === "en" ? EnSchema : ArSchema,
    onSubmit,
  });
  return (
    <Box
      component="form"
      sx={styles.container}
      onSubmit={handleSubmit}
      autoComplete="off"
      noValidate
      style={{
        padding: "24px",
        borderRadius: "16px",
      }}
    >
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
<InputLabel
  sx={(theme) => ({
    ...styles.label(theme),
    whiteSpace: "normal",
    overflow: "visible",
    textOverflow: "unset",
    wordBreak: "break-word",
  })}
>
  {t.full_name}
</InputLabel>
        <TextField
          value={values.person_name}
          onChange={handleChange}
          id="person_name"
          type="string"
          onBlur={handleBlur}
          error={touched.person_name && errors.person_name}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>
          {touched.person_name && errors.person_name}
        </Box>
      </Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          gap: "10px",
          flexWrap: { xs: "wrap", md: "initial" },
        }}
      >
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.phone}</InputLabel>
          <TextField
            value={values.phoneNumber}
            onChange={(event) => {
              const validInput = event.target.value.replace(/[^0-9]/g, "");
              if (validInput.length <= 11) {
                event.target.value = validInput;
                handleChange(event);
              }
            }}
            id="phoneNumber"
            type="text"
            onBlur={handleBlur}
            error={touched.phoneNumber && errors.phoneNumber}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>
            {touched.phoneNumber && errors.phoneNumber}
          </Box>
        </Box>
        <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
          <InputLabel sx={styles.label}>{t.email}</InputLabel>
          <TextField
            value={values.email}
            onChange={handleChange}
            id="email"
            type="text"
            onBlur={handleBlur}
            error={touched.email && errors.email}
            sx={styles.input}
            InputProps={{ sx: { height: "45px" } }}
            variant="outlined"
          />
          <Box sx={styles.helperText}>{touched.email && errors.email}</Box>
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel sx={styles.label}>{t.business_name}</InputLabel>
        <TextField
          value={values.client_name}
          onChange={handleChange}
          id="client_name"
          type="string"
          onBlur={handleBlur}
          error={touched.client_name && errors.client_name}
          sx={styles.input}
          InputProps={{ sx: { height: "45px" } }}
          variant="outlined"
        />
        <Box sx={styles.helperText}>
          {touched.client_name && errors.client_name}
        </Box>
      </Box>
      <Box sx={styles.inputWrapper} style={{ width: "100%" }}>
        <InputLabel sx={styles.label}>{t.governorate}</InputLabel>
        <TextField
          value={values.governorate || "default"}
          onChange={handleChange}
          name="governorate"
          type="text"
          onBlur={handleBlur}
          error={touched.governorate && errors.governorate}
          sx={styles.input}
          select
          style={{ height: "45px" }}
          InputProps={{
            sx: {
              height: "45px",
              color: "grey",
              lineHeight: "2",
            },
          }}
          SelectProps={{
            MenuProps: {
              PaperProps: {
                style: {
                  marginTop: 1,
                  maxHeight: 300,
                },
              },
            },
          }}
        >
          <MenuItem
            disabled
            value="default"
            className={locale == "en" ? enFont.className : arFont.className}
            sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
          >
            {t.form_labels.g_placeholder}
          </MenuItem>
          {t.governorates.map((option) => (
            <MenuItem
              key={option.id}
              value={option.governorate_name}
              className={locale == "en" ? enFont.className : arFont.className}
              sx={{ direction: locale == "ar" ? "rtl" : "ltr" }}
            >
              {option.governorate_name}
            </MenuItem>
          ))}
        </TextField>
        <Box sx={styles.helperText}>
          {touched.governorate && errors.governorate}
        </Box>
      </Box>
      <Button
        aria-label="contact us submit button "
        disabled={isSubmitting}
        type="submit"
        sx={styles.btn}
        style={{
          backgroundColor: isSubmitting ? "#d3d3d3" : color,
          border: `1px solid #74357D`,
        }}
      >
        {isSubmitting ? (
          <CircularProgress size={24} sx={{ color: "#9e9e9e" }} />
        ) : (
          t.send
        )}
      </Button>
    </Box>
  );
}
